import { render, staticRenderFns } from "./DoctorSchedule.vue?vue&type=template&id=01209b4d&scoped=true"
import script from "./DoctorSchedule.vue?vue&type=script&lang=js"
export * from "./DoctorSchedule.vue?vue&type=script&lang=js"
import style0 from "./DoctorSchedule.vue?vue&type=style&index=0&id=01209b4d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01209b4d",
  null
  
)

export default component.exports